import { ALL_LINES, ALL_MODELS, ALL_SERIES } from '../../../constants/seriesFilter.constants';
import { TProductDownloadBrochuresItemData } from '../../@shared/productDownloadBrochures/types/productDownloadBrochures.types';
import { TFilterContextData } from '../fiilterContext';
import {
  TModelCard,
  TPriorModel,
  TProductPriorModelsLineFilter,
  TProductPriorModelsWithFilterFields,
  TProductPriorModelsWithFilterParams,
  TProductPriorModelsWithFilterProps,
} from '../types/productPriorModelsWithFilter.types';

export class ProductPriorModelsWithFilterModel {
  fields?: TProductPriorModelsWithFilterFields;
  readonly cards: { [id: string]: TModelCard };
  readonly params: TProductPriorModelsWithFilterParams;

  constructor(props: TProductPriorModelsWithFilterProps) {
    this.fields = props.fields || {};
    this.params = props.params || {};
    this.cards = {};
    props.fields?.apiData?.cards?.forEach((eachCard) => {
      eachCard['id'] && (this.cards[eachCard['id']] = eachCard);
    });
  }

  get filters(): TProductPriorModelsLineFilter[] {
    return this.fields?.apiData?.filters || [];
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get shouldShowSearchBox(): boolean {
    return this.params.disableSearch !== '1';
  }

  get numberOfRows(): number {
    return Number(this.params?.numberOfRows) || 4;
  }

  brochuresItemData(): TProductDownloadBrochuresItemData {
    const { itemData } = this.fields || {};
    return {
      thumbnail: '',
      contextItemUrl: itemData?.contextItemUrl,
      iconsList: itemData?.iconsList || [],
      fields: {
        imageParameters: itemData?.fields?.imageParameters || {
          desktopImageData: { url: '' },
          mobileImageData: { url: '' },
        },
      },
    };
  }

  filterCardsBySearch(cards: TModelCard[], searchTerm: string): TModelCard[] {
    if (!searchTerm) return cards;
    return cards?.filter((_) => _.title?.toLocaleLowerCase()?.includes(searchTerm));
  }

  filterCards = (selectedFilters: TFilterContextData): TModelCard[] => {
    const cardsWithKeyAsId = this.cards;
    const { lineSelectedInd, seriesSelectedInd, modelSelectedInd, searchedTerm } = selectedFilters;
    let filteredCardIds: TPriorModel[] = [];
    const allCards = this.fields?.apiData?.cards || [];

    if (searchedTerm) return this.filterCardsBySearch(allCards, searchedTerm?.toLocaleLowerCase());

    if (lineSelectedInd === ALL_LINES) return allCards;
    if (seriesSelectedInd === ALL_SERIES) filteredCardIds = this.filters[lineSelectedInd]?.priorModels || [];
    if (seriesSelectedInd !== ALL_SERIES && modelSelectedInd === ALL_MODELS)
      filteredCardIds = this.filters[lineSelectedInd]?.items?.[seriesSelectedInd]?.priorModels || [];
    if (seriesSelectedInd !== ALL_SERIES && modelSelectedInd !== ALL_MODELS)
      filteredCardIds = this.filters[lineSelectedInd]?.items?.[seriesSelectedInd]?.items?.[modelSelectedInd]?.priorModels || [];

    return filteredCardIds?.map(({ id = '' }) => cardsWithKeyAsId[id])?.filter((_) => _);
  };
}
